<template>
    <div class="member-information">
        <div class="common-header-wrap">
            <mt-header :title="$t('hunt60')" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>
        <div class="news">
            <div class="news_tle">{{ val.title }}</div>
            <div class="news_desc" v-html="decodedContent()"></div>
            <div class="news_time">
                {{ val.created_time || '' }}
            </div>
        </div>
    </div>
</template>


<script>
import { NoticeInfo } from '../../../api/memberOne'
import he from 'he'
export default {
    name: 'HuntNewsDes',
    data() {
        return {
            val: {},
            content: '',
        }
    },
    created() {
        const data = this.$route.query.data || '{}';
        try {
            // JSON.parse(data)
            this.onNoticeInfo(data)
        } catch (error) {
            console.error('JSON parse error:', error);
            // this.val = {};
        }
    },
    methods: {
        onNoticeInfo(v) {
            NoticeInfo({
                id: v
            }).then(res => {
                if (res && res.result) {
                    this.val = res.result
                    this.content = res.result.content
                }
            })
        },
        decodedContent() {
            // 将被转义的字符串解码为正常的 HTML 格式
            return he.decode(this.content)
        }
    }
}
</script>


<style lang="scss" scoped>
.member-information {
    display: flex;
    flex-direction: column;
    height: 100vh;

    .news {
        overflow-y: auto;
        display: flex;
        flex: 1;
        flex-direction: column;
        padding: 17px 8px 20px;
        box-sizing: border-box;

        .news_tle {
            text-align: center;
        }

        .news_desc {
            line-height: 30px;
            font-size: 14px;
            padding: 10px;
            max-width: 100%;
            box-sizing: border-box;
            overflow-wrap: break-word;
            word-break: break-word;
            white-space: pre-line;
        }

        .news_time {
            padding-top: 20px;
            text-align: right;
            color: #999999;
            font-size: 12px;
        }
    }

}
</style>
